let contact = {
  mail: "aditya@abnca.in",
  whatsapp: "+91 9886073051",
  phone: "+91 98860 73051",
  telegram: "MAKE05",
};

export default contact;
